// Máquina de estados do saque (`spec/09-withdrawals.md` §4.4) virando `Pill`.
// A lista vem do contrato gerado (`WithdrawalStatus`), então status novo na API quebra o
// typecheck aqui em vez de aparecer sem rótulo na tela.
//
// `STATUS_META` continua falando `PillTone` porque `features/balance/*` e
// `features/admin-withdrawals/*` importam este mapa e ainda desenham com `Pill`. Desde
// WEB-117 a união é local: a tela Zenith não importa nada do kit, e o tipo é o mesmo.

import type { WithdrawalStatus } from '../../api/queries/withdrawals.ts';

/** Mesma união do `PillTone` do kit; local para esta feature não depender do kit. */
type PillTone = 'ok' | 'wait' | 'bad' | 'neutral' | 'info';

export const STATUS_META: Record<WithdrawalStatus, { label: string; tone: PillTone }> = {
  awaiting: { label: 'Aguardando', tone: 'wait' },
  approved: { label: 'Aprovado', tone: 'info' },
  processing: { label: 'Processando', tone: 'wait' },
  successful: { label: 'Pago', tone: 'ok' },
  failed: { label: 'Falhou', tone: 'bad' },
  rejected: { label: 'Recusado', tone: 'bad' },
  cancelled: { label: 'Cancelado', tone: 'neutral' },
};

export const STATUS_ORDER: WithdrawalStatus[] = [
  'awaiting',
  'approved',
  'processing',
  'successful',
  'failed',
  'rejected',
  'cancelled',
];

/** Cancelar só existe em `awaiting` (`spec/09` §5, `409 invalid_state` fora dele). */
export function canCancel(status: WithdrawalStatus): boolean {
  return status === 'awaiting';
}

/**
 * Abas do croqui (`screens/seller/saques.tsx`). "Falhou/recusado" junta dois status: a
 * API só filtra por UM `status`, então essa aba é a única que pede duas consultas.
 */
export const TAB_IDS = ['all', 'awaiting', 'processing', 'successful', 'failed'] as const;
export type TabId = (typeof TAB_IDS)[number];

export const TAB_LABEL: Record<TabId, string> = {
  all: 'Todos',
  awaiting: 'Aguardando',
  processing: 'Processando',
  successful: 'Pagos',
  failed: 'Falhou/recusado',
};

/** Status que cada aba conta e busca. `all` = todos os sete. */
export const TAB_STATUSES: Record<TabId, WithdrawalStatus[]> = {
  all: STATUS_ORDER,
  awaiting: ['awaiting'],
  processing: ['processing'],
  successful: ['successful'],
  failed: ['failed', 'rejected'],
};

/** Contagem da aba a partir de `counters.withdrawals` (todos os campos são opcionais). */
export function tabCount(
  counts: Partial<Record<WithdrawalStatus, number>> | undefined,
  tab: TabId,
): number | undefined {
  if (counts === undefined) {
    return undefined;
  }
  return TAB_STATUSES[tab].reduce((total, status) => total + (counts[status] ?? 0), 0);
}
